import React from 'react'
import { FormattedMessage } from 'react-intl'

export const MODERNIZATION_OVERLAY_TITLE = (
    <FormattedMessage
        id='modernization_overlay.title'
        defaultMessage='О модернизации'
    />
)



// WEBPACK FOOTER //
// ./components/ModernizationOverlay/constants.jsx